import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=c171dbb0&scoped=true&lang=html&"
import script from "./AddFriend.vue?vue&type=script&lang=js&"
export * from "./AddFriend.vue?vue&type=script&lang=js&"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=c171dbb0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c171dbb0",
  null
  
)

export default component.exports